/**
 * Generated bundle index. Do not edit.
 */
export { MatSnackBarModule, MatSnackBar, SHOW_ANIMATION, HIDE_ANIMATION, MatSnackBarContainer, MAT_SNACK_BAR_DATA, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from './public-api';
//# sourceMappingURL=index.js.map